import React, { lazy, Suspense } from 'react';
import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
} from 'react-router-dom';
import { AppLoading } from 'components/loading';
import NewDashboard from 'container/Dashboard/new-dashboard';
import ChooseTemplate from 'container/Products/ChooseTemplate';
import CreateProduct from 'container/Products/CreateProduct';
import ProductView from 'container/Products/ProductView';
import ProductsList from 'container/Products/ProductsList';
import ScrollToTop from 'components/ScrollToTop';
import EditProduct from 'container/Products/EditProduct/EditProduct';
import Guides from 'container/Guides';
import Terminal from 'container/Terminal';
import TerminalDetails from 'container/Terminal/TerminalDetails';
import NewAuthenticatedRoute from './NewAuthenticatedRoute';
import AuthenticaedRoute from './AuthenticatedRoute';
import UnauthenticaedRoute from './UnauthenticaedRoute';
import {
  BASE,
  INDEX,
  REGISTER,
  LOGIN,
  PRODUCTS,
  SETTINGS,
  ALL_COLLECTIONS,
  TEAM_MEMBER_INVITATION,
  CASH_OUT,
  SETTLEMENT,
  SETTLEMENT_DETAIL,
  WALLET,
  ALL_REGISTRATIONS,
  ACTIVATE_EMAIL,
  RESEND_EMAIL,
  VERIFY_EMAIL,
  RESET_PASSWORD,
  RESET_PASSWORD_TWO,
  ONBOARDING,
  CREATE_PRODUCT,
  TRANSACTIONS,
  NEWSETTINGS,
  CHOOSE_TEMPLATE,
  VIEW_PRODUCT,
  EDIT_PRODUCT,
  TERMINAL,
  TERMINAL_DETAILS,
  CUSTOMERS,
  CUSTOMER_DETAILS,
  CUSTOMER_CATEGORIES,
  GUIDES,
  TERMINAL_ORDER,
} from './routes';

const SignIn = lazy(() => import('container/Auth/SignIn'));
const SignUp = lazy(() => import('container/Auth/SignUp'));
const ActivateEmail = lazy(() => import('container/Auth/ActivateEmail'));
const ResendEmail = lazy(() => import('container/Auth/ResendEmail'));
const VerifyEmail = lazy(() => import('container/Auth/Verifying'));
const ForgotPassword = lazy(() => import('container/Auth/ForgotPassword'));
const Wallets = lazy(() => import('container/Wallet'));

const ResetPasswordTwo = lazy(() => import('container/Auth/ResetPassword_Two'));
const NotFound = lazy(() => import('container/NotFound'));

const Settlement = lazy(() => import('container/Settlement'));
const SettlementDetail = lazy(() => import('container/Settlement/details'));
const Transactions = lazy(() => import('container/Transactions'));
const onboarding = lazy(() => import('container/Onboarding'));
const NewSettings = lazy(() => import('container/NewSettings'));
const TeamMemberInvitation = lazy(() => import('container/Auth/Invitation'));
const Customers = lazy(() => import('container/Customers'));
const CustomerDetails = lazy(() => import('container/Customers/details'));
const CustomerCategories = lazy(() => import('container/Customers/categories'));
const TerminalOrders = lazy(() => import('container/Terminal/Order'));

const RouterIndex = (props) => (
  <>
    <ScrollToTop>
      <Router>
        <Suspense fallback={<AppLoading />}>
          <Switch>
            <NewAuthenticatedRoute
              exact
              path={TERMINAL_ORDER}
              component={TerminalOrders}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={INDEX}
              component={NewDashboard}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={PRODUCTS}
              component={ProductsList}
              props={props}
            />

            <NewAuthenticatedRoute
              exact
              path={VIEW_PRODUCT}
              component={ProductView}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={CHOOSE_TEMPLATE}
              component={ChooseTemplate}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={WALLET}
              component={Wallets}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={CREATE_PRODUCT}
              component={CreateProduct}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={EDIT_PRODUCT}
              component={EditProduct}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={SETTLEMENT}
              component={Settlement}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={SETTLEMENT_DETAIL}
              component={SettlementDetail}
              props={props}
            />
            <NewAuthenticatedRoute
              path={NEWSETTINGS}
              component={NewSettings}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={TRANSACTIONS}
              component={Transactions}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={TERMINAL}
              component={Terminal}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={TERMINAL_DETAILS}
              component={TerminalDetails}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={GUIDES}
              component={Guides}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={CUSTOMERS}
              component={Customers}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={CUSTOMER_CATEGORIES}
              component={CustomerCategories}
              props={props}
            />
            <NewAuthenticatedRoute
              exact
              path={CUSTOMER_DETAILS}
              component={CustomerDetails}
              props={props}
            />

            <AuthenticaedRoute
              exact
              path={ONBOARDING}
              component={onboarding}
              props={props}
            />
            {/* <AuthenticaedRoute
        exact
        path={INDEX}
        component={Dashboard}
        props={props}
      /> */}
            <UnauthenticaedRoute
              exact
              path={LOGIN}
              component={SignIn}
              props={props}
            />
            <UnauthenticaedRoute
              exact
              path={RESET_PASSWORD_TWO}
              component={ResetPasswordTwo}
              props={props}
            />
            <UnauthenticaedRoute
              exact
              path={RESET_PASSWORD}
              component={ForgotPassword}
              props={props}
            />
            <UnauthenticaedRoute
              exact
              path={REGISTER}
              component={SignUp}
              props={props}
            />
            <UnauthenticaedRoute
              exact
              path={ACTIVATE_EMAIL}
              component={ActivateEmail}
              props={props}
            />
            <UnauthenticaedRoute
              exact
              path={RESEND_EMAIL}
              component={ResendEmail}
              props={props}
            />
            <UnauthenticaedRoute
              exact
              path={VERIFY_EMAIL}
              component={VerifyEmail}
              props={props}
            />
            <UnauthenticaedRoute
              path={TEAM_MEMBER_INVITATION}
              component={TeamMemberInvitation}
              props={props}
              exact
            />
            <NewAuthenticatedRoute
              exact
              path={BASE}
              component={NewDashboard}
              props={props}
            />
            <Route path="*" component={NotFound} />
          </Switch>
        </Suspense>
      </Router>
    </ScrollToTop>
  </>
);

export default RouterIndex;
